import React from 'react'
import { FaArrowDown, FaArrowUp, FaRegCopy, FaTrash } from 'react-icons/fa'
import { BtnIcon } from '../../../../components'
import * as colors from '../../../../assets/js/colors'

const styles = {
  container: { display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' },
  oculto: { visibility: 'hidden' },
}

export default function AcoesLinha({
  primeiro,
  ultimo,
  podeRemover = true,
  onMover,
  onDuplicar = null,
  onRemover,
}) {
  return (
    <div style={styles.container}>
      <span title="Mover para cima" style={primeiro ? styles.oculto : null}>
        <BtnIcon onClick={() => onMover(-1)}>
          <FaArrowUp color={colors.azul} />
        </BtnIcon>
      </span>
      <span title="Mover para baixo" style={ultimo ? styles.oculto : null}>
        <BtnIcon onClick={() => onMover(1)}>
          <FaArrowDown color={colors.azul} />
        </BtnIcon>
      </span>
      {onDuplicar ? (
        <span title="Duplicar">
          <BtnIcon onClick={onDuplicar}>
            <FaRegCopy color={colors.azul} />
          </BtnIcon>
        </span>
      ) : null}
      <span title="Remover" style={podeRemover ? null : styles.oculto}>
        <BtnIcon onClick={onRemover}>
          <FaTrash color="red" />
        </BtnIcon>
      </span>
    </div>
  )
}
